import React from 'react';

export function MarkdownImage({
  alt = '',
  src = '',
  url = src,
}: {
  alt?: string;
  src?: string;
  url?: string;
}): React.JSX.Element {
  return <img alt={alt} src={url} />;
}
